import useAttendanceScan, {
    ATTENDANCE_ACTIONS,
    ATTENDANCE_SCAN_STATES
} from "./use-attendance-scan";
import useAttendanceMutationScan from "./attendance-use-mutation-scan";
import useAttendanceFeedbackAudio from "./use-attendance-feedback-audio";
import useAttendanceSession from "./use-attendance-session";


const AttendanceHooks = {
    useScan: useAttendanceScan,
    useMutationScan: useAttendanceMutationScan,
    useFeedbackAudio: useAttendanceFeedbackAudio,
    useSession: useAttendanceSession
};

export {
    ATTENDANCE_ACTIONS,
    ATTENDANCE_SCAN_STATES,
    useAttendanceScan,
    useAttendanceMutationScan,
    useAttendanceFeedbackAudio,
    useAttendanceSession
};

export default AttendanceHooks;
